import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";

import LeftDrawer from "./LeftDrawer";
import DashboardBreadcrumbs from "./DashboardBreadcrumbs";
import DDSStatusBanner from "../../components/resilience/DDSStatusBanner";

import { useUI } from "../../contexts/UIContext";
import darkTheme from "../../styles/theme";
import { rememberRoute } from "../../utils/lastRoute";
import { getStoredSession } from "../../utils/sessionManager";

const DRAWER_WIDTH = 275;

export default function DashboardLayout({ rightAction }) {
  const { isDrawerOpen } = useUI();
  const location = useLocation();

  // Remember where the operator is, so re-entering Aether from the dashboard
  // resumes here instead of always landing on Competitions. This layout wraps
  // every protected route, so it is the one place that sees them all.
  React.useEffect(() => {
    rememberRoute(`${location.pathname}${location.search}`, getStoredSession()?.userId);
  }, [location.pathname, location.search]);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      {/* Persistent Left Drawer */}
      <LeftDrawer />

      {/* Main Content Area */}
      <Box
        sx={{
          width: isDrawerOpen
            ? `calc(100% - ${DRAWER_WIDTH}px)`
            : "calc(100% - 0.5em)",
          ml: isDrawerOpen ? `${DRAWER_WIDTH -8}px` : 0,
          height: "100vh",
          p: '.5rem',
          overflow: "hidden",
          // Containing block for DDSStatusBanner, which overlays this area
          // instead of sitting in flow (OPUS-1466). Without this the banner
          // would position against the viewport and ignore the drawer offset.
          position: "relative",
          transition: "all 0.25s ease",
          borderRadius: 1,
        }}
      >
        {/* Breadcrumbs */}
        {/* <DashboardBreadcrumbs rightAction={rightAction} /> */}

        {/* Live-data connection state. Without this a DDS outage is invisible:
            subscriptions error to the console and the UI silently freezes on
            stale data, so the operator sees a stopped clock with no way to tell
            whether the app is broken or the feed is.

            OPUS-1466: this OVERLAYS the content rather than sitting in flow.
            This Box is height:100vh / overflow:hidden, so a banner in flow
            permanently shrank the routed page below the fold with no scrollbar
            to reach it. */}
        <DDSStatusBanner />

        {/* Routed Content */}

          <Outlet />
        
      </Box>
    </ThemeProvider>
  );
}
